const ContentCollapse = ({id, body}) => {
    return(
        <div class="collapse" id={`collapseDoctorado${id}`}>                        
            {body.map((obj) => {
                return(
                        <p key={ obj.id} style={{textAlign: 'justify'}}>
                            {obj.title} {obj.status_label}
                        </p>
                )
            })}
        </div>
      
    )
}


const TitleCollapse = ({id, title}) =>{
    return(
        <> 
        <h5 
        className="my-4 text-center "
        data-bs-toggle="collapse" 
        href={`#collapseDoctorado${id}`}
        role="button" 
        aria-expanded="false" 
        aria-controls="collapseExample">
                {title}
        </h5>
        <hr />
        </>
    )
}


const TTitle = ({title}) => {
    return(
        <h4 className="text-center fw-bolder header-tesis-card">{title}</h4>
    )
}

// eslint-disable-next-line no-unused-vars
const TCollapse = ({tag, body}) => {
    return(
        <>
        <TTitle title={tag}/>
        {body.map((tesis) => {
            return(
                <div key={tesis.title}>
                    <TitleCollapse id={tesis.id} title={tesis.puesto}></TitleCollapse>
                    <ContentCollapse id={tesis.id} body={tesis.tesis}></ContentCollapse>
                </div>
            )
        })}

        </>
    )
}

const TCard = ({children}) => {
    return(
        <div className="card card-tesis-container col-md-3 p-4">
            <div className="card-tesis">
                {children}
            </div>  
        </div>
    )
}

const SectionTesis = (props) =>{
    return(
        <div className="container">
            <div className="row gap-5 d-flex justify-content-around">
                {
                    props.tesisTypes.map((type)=>{
                        return(
                            <TCard key={type.title}>
                                <>
                                    <TTitle title={type.title}/>
                                    {
                                        props.tesisCategories.map((category) => {
                                            if ( props.tesis[type.id][category.id] )
                                            {
                                                return(
                                                    <div key={category.title}>
                                                        <TitleCollapse id={type.id+category.id} title={category.title}></TitleCollapse>
                                                        <ContentCollapse id={type.id+category.id} body={props.tesis[type.id][category.id]}></ContentCollapse>
                                                    </div>
                                                )
                                            }
                                            else
                                            {
                                                return null
                                            }
                                        })
                                    }
                                </>
                            </TCard>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SectionTesis;